import { render, staticRenderFns } from "./D101.vue?vue&type=template&id=710d4652&scoped=true"
import script from "./D101.vue?vue&type=script&lang=js"
export * from "./D101.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=710d4652&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710d4652",
  null
  
)

export default component.exports